import { Stack, Typography, Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { formatDateTime } from "../../utils";
import { NewCardState, newCardStates } from "./enums/NewCardStates";
import { CardSwapUpdateDto } from "./dtos/CardSwapUpdateDto";
import { useContext, useEffect, useState } from "react";
import VspPortalContext from "../../store/VspPortalContext";
import { CardSwapStatusCode, cardSwapStatusCodes } from "./enums/CardSwapStatusCode";
import { useCardSwapHttp } from "./hooks/useCardSwapHttp";
import { CardSwapSearchResultDto } from "./dtos/CardSwapSearchResultDto";

type NewCardToggleProps = {

    cardSwapSearchResultDto:  CardSwapSearchResultDto;
    isUpdating : boolean;
    setDialogHeader( dialogHeader : string ) : void;
    setIsUpdated( isUpdated : boolean ) : void ; 
    setIsUpdating( isUpdating : boolean ) : void ;

};


export const NewCardToggle: React.FC< NewCardToggleProps > = ( props : NewCardToggleProps ) => {

    const { cardSwapSearchResultDto, isUpdating, setDialogHeader, setIsUpdated, setIsUpdating } = props;

    const [ cardSwapSearchResult, setCardSwapSearchResult ] = useState< CardSwapSearchResultDto> ( cardSwapSearchResultDto );
    const [ newCardState, setNewCardState ] = useState< NewCardState >( NewCardState.NotCollected );

    const { state } = useContext( VspPortalContext );

    const { updateCardSwap } = useCardSwapHttp( );


    useEffect( ( ) => {

        if( cardSwapSearchResultDto.newCardCollectedDate ){

            setNewCardState( NewCardState.Collected );

        }

    }, [ ]);


    const handleNewCardStateChange = ( newCardState : NewCardState ) => {

        if( !newCardState ) {

            return;

        }

        if( newCardState === NewCardState.Collected ){
            
            markAsCollected( );

        }

        setNewCardState( newCardState );

    };


    const markAsCollected = async( ) => {

        const cardSwapUpdateDto : CardSwapUpdateDto = {

            cardSwapStatusCode : CardSwapStatusCode.NewCardCollected,
            id : cardSwapSearchResultDto.id,
            updatedBy : state.username

        };

        setIsUpdating( true );
        const isSuccess = await updateCardSwap( cardSwapUpdateDto );
        setIsUpdating( false );

        if( isSuccess ){

            setIsUpdated( true );

            const updatedCardSwapSearchResult = { ...cardSwapSearchResult, newCardCollectedDate : new Date( ).toUTCString( )};
            setCardSwapSearchResult( updatedCardSwapSearchResult );

            setDialogHeader( cardSwapStatusCodes[ CardSwapStatusCode.NewCardCollected ] );

        }

    };
    

    return(

        <Stack direction="row" display="flex" alignItems="center" gap={ 0.5 }>
                    
            <Typography sx={{ lineHeight: '45px' }}>
                { cardSwapSearchResultDto.newCardNumber }
            </Typography>

            <Box sx={{ flexGrow: 1 }} />

            <Stack direction="column">
            
                <ToggleButtonGroup
                    color="primary"
                    disabled={ isUpdating }
                    value={ newCardState }
                    exclusive
                    onChange={ ( _: React.MouseEvent<HTMLElement>, newCardState: NewCardState ) => handleNewCardStateChange( newCardState ) }
                >
                    <ToggleButton disabled={ newCardState === NewCardState.Collected } value={ NewCardState.NotCollected } sx={{ textTransform: 'none' }}>{ newCardStates[ NewCardState.NotCollected ] }</ToggleButton>
                    <ToggleButton value={ NewCardState.Collected } sx={{ textTransform: 'none' }}>{ newCardStates[ NewCardState.Collected ] }</ToggleButton>
                </ToggleButtonGroup>

                { 
                    cardSwapSearchResult.newCardCollectedDate 
                        && 
                    <Typography sx={{ fontSize: 12 }}>
                        Collected: { formatDateTime( new Date( cardSwapSearchResult.newCardCollectedDate ) )  }
                    </Typography>
                }

            </Stack>

        </Stack>

    );

};